// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__38bZI","colMaxWidth":"Table_colMaxWidth__2F6LE"};